"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var angular_jwt_1 = require("@auth0/angular-jwt");
exports.default_headers = {};
exports.TOKEN_STORE_ITEM_NAME = "jwt_wicked";
function getAuthToken() {
    return localStorage.getItem(exports.TOKEN_STORE_ITEM_NAME);
}
exports.getAuthToken = getAuthToken;
function setAuthToken(token) {
    if (token && token != "") {
        localStorage.setItem(exports.TOKEN_STORE_ITEM_NAME, token);
    }
    else {
        localStorage.removeItem(exports.TOKEN_STORE_ITEM_NAME);
    }
}
exports.setAuthToken = setAuthToken;
function isTokenExpired() {
    var myRawToken = getAuthToken();
    if (myRawToken) {
        var helper = new angular_jwt_1.JwtHelperService();
        var isExpired = helper.isTokenExpired(myRawToken);
        return isExpired;
    }
    else {
        return true;
    }
}
exports.isTokenExpired = isTokenExpired;
function isAuthenticated() {
    var myRawToken = getAuthToken();
    if (myRawToken) {
        var helper = new angular_jwt_1.JwtHelperService();
        var decodedToken = helper.decodeToken(myRawToken);
        var expirationDate = helper.getTokenExpirationDate(myRawToken);
        var isExpired = helper.isTokenExpired(myRawToken);
        return !isExpired;
    }
    else {
        return false;
    }
}
exports.isAuthenticated = isAuthenticated;
function getUserTokenField(fieldName) {
    //http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname
    if (isAuthenticated()) {
        var myRawToken = getAuthToken();
        if (myRawToken && fieldName && fieldName != "") {
            var helper = new angular_jwt_1.JwtHelperService();
            var decodedToken = helper.decodeToken(myRawToken);
            return decodedToken[fieldName] ? decodedToken[fieldName] : "";
        }
        else {
            return "";
        }
    }
    else
        return "";
}
exports.getUserTokenField = getUserTokenField;
function getUserTokenFieldSchema(fieldName) {
    //surname
    if (isAuthenticated()) {
        var myRawToken = getAuthToken();
        if (myRawToken && fieldName && fieldName != "") {
            var helper = new angular_jwt_1.JwtHelperService();
            var decodedToken = helper.decodeToken(myRawToken);
            if (fieldName == "primarysid" || fieldName == "role") {
                fieldName = "http://schemas.microsoft.com/ws/2008/06/identity/claims/" + fieldName;
            }
            else {
                fieldName = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/" + fieldName;
            }
            return decodedToken[fieldName] ? decodedToken[fieldName] : "";
        }
        else {
            return "";
        }
    }
    else
        return "";
}
exports.getUserTokenFieldSchema = getUserTokenFieldSchema;
